export default __webpack_public_path__ + "static/media/Fitness-Tracker.94bdc0cf.png";